import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Translate from './pages/Translate';
import Cards from './pages/Cards';
import Learn from './pages/Learn';
import Login from './pages/Login';
import Categories from './pages/Categories';
import Library from './pages/Library';
import Stats from './pages/Stats';
import './App.css';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Upgrade from './pages/Upgrade';

function NavBar() {
  const { user, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="navbar">
      <div className="nav-brand">Vocabia</div>

      {user && (
        <>
          {/* Desktop Navigation */}
          <div className="nav-links nav-desktop">
            <Link to="/">Übersetzen</Link>
            <Link to="/cards">Meine Karten</Link>
            <Link to="/learn">Lernen</Link>
            <Link to="/categories">Kategorien</Link>
            <Link to="/library">Bibliothek</Link>
            <Link to="/stats">Auswertungen</Link>
            <span style={{ opacity: 0.7, fontSize: '0.9rem' }}>| {user.name || user.email}</span>
            <button onClick={logout} style={{
              background: 'rgba(255,255,255,0.2)', color: 'white',
              border: 'none', borderRadius: '6px', padding: '0.4rem 0.8rem',
              cursor: 'pointer', fontSize: '0.9rem'
            }}>Abmelden</button>
          </div>

          {/* Mobile Hamburger Button */}
			<button
				className="nav-hamburger"
				onClick={() => setMenuOpen(!menuOpen)}
			>
				<span className="hamburger-line"></span>
				<span className="hamburger-line"></span>
				<span className="hamburger-line"></span>
			</button>

          {/* Mobile Dropdown Menu */}
          {menuOpen && (
            <div className="nav-mobile-menu">
              <Link to="/" onClick={closeMenu}>Übersetzen</Link>
              <Link to="/cards" onClick={closeMenu}>Meine Karten</Link>
              <Link to="/learn" onClick={closeMenu}>Lernen</Link>
              <Link to="/categories" onClick={closeMenu}>Kategorien</Link>
              <Link to="/library" onClick={closeMenu}>Bibliothek</Link>
              <Link to="/stats" onClick={closeMenu}>Auswertungen</Link>
              <div className="nav-mobile-divider" />
              <span className="nav-mobile-user">{user.name || user.email}</span>
              <button onClick={() => { logout(); closeMenu(); }} className="nav-mobile-logout">
                Abmelden
              </button>
            </div>
          )}
        </>
      )}
    </nav>
  );
}

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ padding: '2rem', textAlign: 'center' }}>Laden...</div>;
  return user ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="app">
          <NavBar />
          <main className="main-content">
			<Routes>
				<Route path="/login" element={<Login />} />
				<Route path="/forgot-password" element={<ForgotPassword />} />
				<Route path="/reset-password" element={<ResetPassword />} />
				<Route path="/" element={<PrivateRoute><Translate /></PrivateRoute>} />
				<Route path="/cards" element={<PrivateRoute><Cards /></PrivateRoute>} />
				<Route path="/learn" element={<PrivateRoute><Learn /></PrivateRoute>} />
				<Route path="/categories" element={<PrivateRoute><Categories /></PrivateRoute>} />
				<Route path="/library" element={<PrivateRoute><Library /></PrivateRoute>} />
				<Route path="/stats" element={<PrivateRoute><Stats /></PrivateRoute>} />
				<Route path="/upgrade" element={<PrivateRoute><Upgrade /></PrivateRoute>} />
				<Route path="/upgrade-success" element={<PrivateRoute><Upgrade /></PrivateRoute>} />
			</Routes>
          </main>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;